import React, { useState, useEffect, useCallback } from 'react';
import { Box, CircularProgress, Divider, Grid, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { getTransit, lifeCycleSnapshot } from '../../services/vehicles';
import { META_DATA_MODULES, META_DATA_SUB_MODULES } from '../../utils/constants';
import useMetaData from '../../hooks/useMetaData';
import StepperVertical from '../../components/Stepper/StepperVertical';
import StageLifecycle from '../StageLifecycle';
import { contentType, handleContent } from '../Reservation';

const Transit = () => {
  // const VIN = useSelector((state: RootState) => state.vehicle.data.VIN);
  // const metaData = useMetaData(META_DATA_MODULES.v360Page, META_DATA_SUB_MODULES.transitTab);
  // const [data, setData] = useState<any>({});
  // const [loading, setLoading] = useState<boolean>(false);

  // useEffect(() => {
  //   if (VIN) {
  //     setLoading(true);
  //     getTransit(VIN)
  //       .then((response) => {
  //         setData(response);
  //         setLoading(false);
  //       })
  //       .catch((error: any) => {
  //         setLoading(false);
  //       });
  //   }
  // }, [VIN]);

  // if (!metaData || loading) return <>Loading...</>;

  // use hooks
  const { reservationId } = useParams<{ reservationId: string }>();
  const metaData = useMetaData(META_DATA_MODULES.v360Page, META_DATA_SUB_MODULES.LifeCycleSnapShot);

  // local sates
  const [transitData, setTransitData] = useState<any>(null);

  // constants
  const stepsVertical = transitData?.stageInformation
    ?.sort((a: any, b: any) => parseFloat(b?.sequence) - parseFloat(a?.sequence))
    ?.filter(
      (fil: { ruleResult: { isCompleted: boolean }; subStage: string; showSubStage: boolean }) => fil?.showSubStage
    )
    ?.map((item: any) => {
      return {
        id: '1',
        label: (
          <Typography variant="body2" fontWeight={500} fontSize={16} color="#1F1F1F">
            {metaData?.fields?.[item?.subStage]?.caption}
          </Typography>
        ),
        content: <>{handleContent(item?.ruleResult, metaData?.fields?.[item?.subStage])}</>,
        isCompleted: item?.ruleResult?.isCompleted,
      };
    });

  // fetching record
  const fetchProductionData = useCallback(async () => {
    try {
      const resp = await lifeCycleSnapshot({
        method: 'POST',
        data: {
          reservationId,
          stages: ['Transit'],
          langCode: 'en-us',
        },
      });
      setTransitData(resp?.data?.data?.[0]);
    } catch (error) {
      console.log(error);
    }
  }, [reservationId]);

  // lifecycle hooks
  useEffect(() => {
    fetchProductionData();
  }, [fetchProductionData]);

  if (!transitData)
    return (
      <Box sx={{ position: 'relative', minHeight: '250px' }}>
        <CircularProgress
          color="inherit"
          size={18}
          sx={{ position: 'absolute', left: '0', right: '0', top: '50%', margin: '0 auto' }}
        />
      </Box>
    );
  return (
    <Box>
      <Typography fontSize={20} mb={1.2} fontWeight={500} lineHeight="24px">
        Transit Lifecycle
      </Typography>
      <Grid item xs={12} mb={1}>
        <Divider sx={{ borderColor: '#e3e3e3' }} />
      </Grid>
      <StepperVertical steps={stepsVertical} activeStep={stepsVertical?.length ?? 10} />
      {/* <StageLifecycle
        label={metaData.transitLifecycle.label}
        data={data}
        metaData={metaData.transitLifecycle.content}
      /> */}
    </Box>
  );
};
export default Transit;
